module.exports = __webpack_public_path__ + "/d638b5962cd1f15e843b40ad0aef944e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/x@2x.png
 ** module id = 815
 ** module chunks = 0 1
 **/